import axios from "axios";
import { CONSTS } from "src/consts/consts";

const mainUrl                        = process.env.REACT_APP_MAIN_URL;
const SEND_REGISTER_FORM_API_URL     = mainUrl + CONSTS.WORKER_SEND_REGISTER_FORM;
const GET_ALL_WORKERS_API_URL        = mainUrl + CONSTS.WORKER_GET_ALL;
const UPLOAD_FILE                    = mainUrl + CONSTS.WORKER_UPLOAD_FILE;
const UPDATE_REGISTER_FORM_API_URL   = mainUrl + CONSTS.WORKER_UPDATE;
const GET_WORKER_EXTRA_BY_ID_API_URL = mainUrl + CONSTS.WORKER_GET_EXTRA_BY_ID;
const SEND_NEW_PASSWORD              = mainUrl + CONSTS.WORKER_SEND_NEW_PASSWORD;
const REGISTER_WORKER_API_URL        = mainUrl + CONSTS.WORKER_REGISTER;


export const WorkerService = {
  SEND_REGISTER_FORM: async(newWorker) => {  
    let arr = [];
    newWorker.vocationalTagList.map(t=>arr.push({id:0,stringValue:t.label,stringGroup:""}));
    let data = {...newWorker,vocationalTagList :arr} 
    return await axios.post(SEND_REGISTER_FORM_API_URL, data)
  },
  UPDATE_WORKER_REGISTER_FORM: async (workerId,newWorker) => { 
    console.log("cihan"); 
    let arr = [];
    newWorker.vocationalTagList.map(t=>arr.push({id:0,stringValue:t.label,stringGroup:""}));
    let data = {...newWorker,vocationalTagList :arr} 
    return  await axios.post(UPDATE_REGISTER_FORM_API_URL+`?workerId=${workerId}`, data);
  },
  REGISTER_WORKER: async(workerId) => {  
    return await axios.post(REGISTER_WORKER_API_URL+`?workerId=${workerId}`);
  },

  GET_WORKER_EXTRA_BY_ID: async(workerId) => {  
    return await axios.get(GET_WORKER_EXTRA_BY_ID_API_URL+`?workerId=${workerId}`);
  },

  GET_OUR_WORKERS: async() => {
    var filter = { isRegisteredFilterActive : true, isRegistered : true, isForeignWorkerFilterActive : true, isForeignWorker : false, isVocationalTagFilterActive : false, hasAnyDocumentsNeedRenewalFilterActive : false }
      return await axios.post(GET_ALL_WORKERS_API_URL, filter);
  },

  GET_HIRED_WORKERS: async() => {
    var filter = { isRegisteredFilterActive : true, isRegistered : true, isForeignWorkerFilterActive : true, isForeignWorker : true, isVocationalTagFilterActive : false, hasAnyDocumentsNeedRenewalFilterActive : false }  
    return await axios.post(GET_ALL_WORKERS_API_URL, filter);
  },

  GET_WORKERS_DOCUMENTS_NEED_RENEWAL: async() => {
    var filter = { isRegisteredFilterActive : false, isForeignWorkerFilterActive : false, isVocationalTagFilterActive : false, hasAnyDocumentsNeedRenewalFilterActive : true, hasAnyDocumentsNeedRenewal : true }
    return await axios.post(GET_ALL_WORKERS_API_URL, filter);
  },

  GET_PREWORKERS: async() => {
    var filter = { isRegisteredFilterActive : true, isRegistered : false, isForeignWorkerFilterActive : true, isForeignWorker : false, isVocationalTagFilterActive : false, hasAnyDocumentsNeedRenewalFilterActive : false }
    return await axios.post(GET_ALL_WORKERS_API_URL, filter);
  },

  UPLOAD_FILE: async(file) => {  
    const formData = new FormData();
    formData.append("formFile",file);
    formData.append("fileName",file.name);
    return await axios.post(UPLOAD_FILE, formData)
  },

  SEND_NEW_PASSWORD: (workerId) => {
    return axios.post(SEND_NEW_PASSWORD, workerId);
  }
};
